import React from 'react';
import {Empty} from 'antd-mobile';
import {t} from "../i18n";

interface EmptyStateProps {
  description?: string;
  imageWidth?: number;
}

const EmptyPodReviewState: React.FC<EmptyStateProps> = ({
  description = t('pages.noViolationRecords'),
  imageWidth = 128
}) => {
  return (
    <div className="flex flex-col h-screen">
        <div className="flex-1 flex items-center justify-center">
            <Empty
                description={description}
                imageStyle={{ width: imageWidth }}
            />
        </div>
    </div>
  );
};

export default EmptyPodReviewState;